//获取cookie、
export function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return arr[2]
  else return null
}
//设置cookie,增加到vue实例方便全局调用
// export function setCookie (c_name, value, expiredays) {
//     var Days = 30;
//     var exdate = new Date();
//     exdate.setTime(exdate.getTime() + Days*24*60*60*1000);

//     //  document.cookie = c_name + "=" + escape(value) + ";path=/;domain=netban.cn;expires=" +((expiredays == null) ? '' : + exdate.toGMTString());
//     document.cookie = c_name + "=" + escape(value) + ";path=/;expires=" +((expiredays == null) ? '' : + exdate.toGMTString());
// }
export function setCookie(c_name, value, expiredays) {
  // var Days = 30;
  if (window.location.host.indexOf('localhost') != -1) {
    var domain = 'localhost'
  } else {
    if (window.location.host == 'ks.netclass.cn') {
      var domain = '.netclass.cn'
    } else {
      var domain = '.netban.cn'
    }
  }

  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  // exdate.setTime(exdate.getTime() + Days*24*60*60*1000);
  document.cookie =
    c_name +
    '=' +
    escape(value) +
    ';path=/' +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString()) +
    (domain == null ? '' : ';domain=' + domain)
}

//删除cookie
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null)
    document.cookie =
      name +
      '=' +
      cval +
      ";path=/;domain=.netban.cn + ';expires= " +
      exp.toGMTString()
}
